module.exports = __webpack_public_path__ + "img/chevron-left.f348ad99.svg";